import { createAsyncThunk, createAction } from "@reduxjs/toolkit";

import api from "./api";

export const getUserProfile = createAsyncThunk(
  "getUserProfile",
  async (data) => {
    if (data?.id) {
      const userProfile = await api.get(`/user/${data?.id}`);
      if (userProfile.status === 200 && userProfile.data) {
        return userProfile?.data?.mentor || userProfile?.data;
      }
      return userProfile;
    } else {
      const userProfile = await api.get("profile/profile_info");
      if (userProfile.status === 200 && userProfile.data) {
        return userProfile.data;
      }
      return userProfile;
    }
  }
);

export const updateLocalProfileInfo = createAction(
  "update/updateLocalProfileInfo"
);

export const updateProfile = createAsyncThunk("updateProfile", async (data) => {
  const userProfile = await api.put("profile/edit_profile", data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  if (userProfile.status === 200 && userProfile.data) {
    return userProfile.data;
  }
  return userProfile;
});

export const updateProfileImage = createAsyncThunk(
  "updateProfileImage",
  async (data) => {
    // api.interceptors.request.use(function (config) {
    //     config.headers["Content-Type"] = "multipart/form-data";
    //     return config;
    // });
    const headers = {
      "Content-Type": "multipart/form-data",
    };
    const userImage = await api.patch("profile/upload_image", data, {
      headers: headers,
    });
    if (userImage.status === 200 && userImage.data) {
      return userImage.data;
    }
    return userImage;
  }
);

export const updateProfileImageById = createAsyncThunk(
  "updateProfileImageById",
  async ({ id, data }) => {
    const userImage = await api.patch(`profile/${id}/upload_image`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    if (userImage.status === 200 && userImage.data) {
      return userImage.data;
    }

    return userImage;
  }
);
